<template>
<div class="content">
  <!-- <ul class="sidebar">
    <li id="nav-1" class="active">
      <a href="javascript:products.scrollIntoView(true)">
        <img src="@/images/icons/1.png" alt="icon">
        新华社产品
      </a>
    </li>
    <li id="nav-2">
      <a href="javascript:photosoftwares.scrollIntoView(true)">
        <img src="@/images/icons/2.png" alt="icon">
        图片编辑
      </a>
    </li>
    <li id="nav-3">
      <a href="javascript:gifsoftwares.scrollIntoView(true)">
        <img src="@/images/icons/3.png" alt="icon">
        动图制作
      </a>
    </li>
    <li id="nav-4">
      <a href="javascript:videosoftwares.scrollIntoView(true)">
        <img src="@/images/icons/4.png" alt="icon">
        视频制作
      </a>
    </li>
    <li id="nav-5">
      <a href="javascript:h5maker.scrollIntoView(true)">
        <img src="@/images/icons/5.png" alt="icon">
        HTML5制作
      </a>
    </li>
    <li id="nav-6">
      <a href="javascript:sand.scrollIntoView(true)">
        <img src="@/images/icons/6.png" alt="icon">
        三维动画制作
        </a>
    </li>
    <li id="nav-7">
      <a href="javascript:utils.scrollIntoView(true)">
        <img src="@/images/icons/7.png" alt="icon">
        实用工具
      </a>
    </li>
  </ul> -->
  <div class="main-wrapper">
    <main>
      <section id="products" class="tools">
        <h1>新华社技术局产品</h1>
        <div style="display: flex;justify-content: center;flex-wrap: wrap;">
          <card v-for="(item, index) in data.products" :key="index" type="products" :data="item"></card>
          <div style="width: 320px; height: 0px"></div>
          <div style="width: 320px; height: 0px"></div>
          <div style="width: 320px; height: 0px"></div>
        </div>
      </section>

      <!-- <section id="photosoftwares" class="tools">
        <h1>图片编辑</h1>
        <div>
          <card v-for="(item, index) in data.photosoftwares" :key="index" type="photosoftwares" :data="item"></card>
        </div>
      </section>

      <section id="gifsoftwares" class="tools">
        <h1>动图制作</h1>
        <div>
          <card v-for="(item, index) in data.gifsoftwares" :key="index" type="gifsoftwares" :data="item"></card>
        </div>
      </section>

      <section id="videosoftwares" class="tools">
        <h1>视频制作</h1>
        <div>
          <card v-for="(item, index) in data.videosoftwares" :key="index" type="videosoftwares" :data="item"></card>
        </div>
      </section>

      <section id="h5maker" class="tools">
        <h1>HTML5 制作</h1>
        <div>
          <card v-for="(item, index) in data.h5maker" :key="index" type="h5maker" :data="item"></card>
        </div>
      </section>

      <section id="sand" class="tools">
        <h1>三维动画制作</h1>
        <div>
          <card v-for="(item, index) in data.sand" :key="index" type="sand" :data="item"></card>
        </div>
      </section>

      <section id="utils" class="tools">
        <h1>实用工具</h1>
        <div>
          <card v-for="(item, index) in data.utils" :key="index" type="utils" :data="item"></card>
        </div>
      </section> -->
    </main>
  </div>
</div>
</template>

<script>
import Card from '@/components/Card.vue';
import tools from '@/mockdata.js';

// document.addEventListener('scroll', () => {
//   if (window.scrollY <= document.querySelector('#products').offsetTop) {
//     [1, 2, 3, 4, 5, 6, 7].forEach(index => document.querySelector('#nav-' + index).classList.remove('active'));
//     document.querySelector('#nav-1').classList.add('active');
//   } else if (window.scrollY <= document.querySelector('#photosoftwares').offsetTop) {
//     [1, 2, 3, 4, 5, 6, 7].forEach(index => document.querySelector('#nav-' + index).classList.remove('active'));
//     document.querySelector('#nav-2').classList.add('active');
//   } else if (window.scrollY <= document.querySelector('#gifsoftwares').offsetTop) {
//     [1, 2, 3, 4, 5, 6, 7].forEach(index => document.querySelector('#nav-' + index).classList.remove('active'));
//     document.querySelector('#nav-3').classList.add('active');
//   } else if (window.scrollY <= document.querySelector('#videosoftwares').offsetTop) {
//     [1, 2, 3, 4, 5, 6, 7].forEach(index => document.querySelector('#nav-' + index).classList.remove('active'));
//     document.querySelector('#nav-4').classList.add('active');
//   } else if (window.scrollY <= document.querySelector('#h5maker').offsetTop) {
//     [1, 2, 3, 4, 5, 6, 7].forEach(index => document.querySelector('#nav-' + index).classList.remove('active'));
//     document.querySelector('#nav-5').classList.add('active');
//   } else if (window.scrollY <= document.querySelector('#sand').offsetTop) {
//     [1, 2, 3, 4, 5, 6, 7].forEach(index => document.querySelector('#nav-' + index).classList.remove('active'));
//     document.querySelector('#nav-6').classList.add('active');
//   } else if (window.scrollY <= document.querySelector('#utils').offsetTop) {
//     [1, 2, 3, 4, 5, 6, 7].forEach(index => document.querySelector('#nav-' + index).classList.remove('active'));
//     document.querySelector('#nav-7').classList.add('active');
//   }
// });

export default {
  name: 'toolbox-main',
  components: {
    Card,
  },
  data () {
    return {
      data: tools,
    }
  },
};
</script>

<style lang="scss" scoped>
.content {
  overflow: hidden;
  // margin-top: 35px;
} 
.sidebar {
  position: fixed;
  width: 200px;
  top: 0; left: 0; bottom: 0;
  background-color: #e9eef2;
  z-index: 999;
  padding-top: 34px;
  li {
    // margin: 20px 0;
    // border-right: 10px solid #e9eef2;
    // height: 70px;
    // line-height: 70px;
    // font-size: 24px;
    border-bottom: 1px solid #bcc9d5;
    border-top: 1px solid #fff;
    a img {
      width: 30px;
      height: 30px;
      margin: 0;
      display: inline-block;
      vertical-align: middle;
      margin-right: 10px;
    }
    // &.active {border-right: 10px solid #005bac;}
    &.active {
      a {
        border-right: 10px solid #005bac;
        color: #005bac;
      }
    }
    &:hover {
      color: #005bac;
      // a:before {background-position-x: -187px;}
      a {
        color: #005bac;
      }
    }
    &:nth-child(1) {
      border-top: none;
    }
    // &:nth-child(7) {
    //   border-bottom: none;
    // }
    // &:nth-child(3) a:before{background-position-y: -145px;}
    // &:nth-child(4) a:before{background-position-y: -214px;}
    // &:nth-child(5) a:before{background-position-y: -285px;}
    // &:nth-child(6) a:before{background-position-y: -355px;}
    // &:nth-child(7) a:before{background-position-y: -427px;}
  }
  
  img {
    display: block;
    margin: 5px auto;
  }
  a {
    display: block;
    height: 80px;
    line-height: 80px;
    margin: 0 auto;
    font-size: 18px;
    font-weight: 500;
    // font-family: 'SimHei';
    text-align: left;
    padding-left: 20px;
    text-decoration: none;
    // color:#333;
    color: #005bac;
    border-right: 10px solid #e9eef2;
    // height: 70px;
    // line-height: 70px;
    // font-size: 24px;
    &:visited {
      color: inherit;
    }
    // &:before{
    //   content:'';
    //   display: block;
    //   width:24px;
    //   height:24px;
    //   margin:0 auto;
    //   margin-bottom: 15px;
    //   background: url("../images/sidebar.png") no-repeat;
    //   overflow: hidden;
    // }
  }
}

.main-wrapper {
  // margin-left: 200px;
  // height: 2400px;
  main {
    margin: 0 auto;
    padding: 0 40px 0 40px;
    // width: 1000px;
    // padding-bottom: 370px;
    .tools {
      padding-bottom: 100px;
      max-width: 1280px;
      margin: 0 auto;
    }
    .tools > h1 {
      margin-top: 1em;
      margin-bottom: 0.8em;
      font-size: 1.2em;
      font-weight: 600;
    }
    .tools > div {
      border-radius: 6px;
      background-color: rgb(245, 247, 250);
      padding: 20px;
    }
  }
}

// main {
//   margin-left: 250px;
//   width: 1000px;
//   padding-bottom:200px;
//   .tools > h1 {
//     margin-top: 1em;
//     margin-bottom: 0.8em;
//     font-size: 1.2em;
//     font-weight: 600;
//   }
//   .tools > div {
//     border-radius: 6px;
//     background-color: rgb(245, 247, 250);
//     padding: 20px;
//   }
// }
</style>
